import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

import { getInviteProgram } from '../../api/inviteApi';
import WhatQuizElephant from '../../components/brand/WhatQuizElephant';
import { useAuth } from '../../contexts/AuthContext';
import './InviteWelcomePage.css';


const InviteWelcomePage = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getInviteProgram()
      .then((result) => {
        if (!cancelled) setPolicy(result);
      })
      .catch(() => {
        if (!cancelled) setPolicy(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const signupEnabled = Boolean(policy?.signup_enabled);
  const discountEnabled = Boolean(policy?.payment_discount_enabled);
  const hasBenefits = signupEnabled || discountEnabled;
  const handleStart = () => {
    navigate(currentUser ? '/home' : '/auth');
  };

  return (
    <main className="invite-welcome-page">
      <Helmet>
        <title>친구 선생님이 추천한 왓퀴즈</title>
        <meta
          name="description"
          content="생기부, PPT, 학습지, 채점을 빠르게 만드는 교사 전용 AI 도구를 확인해보세요."
        />
        <meta property="og:title" content="친구 선생님이 왓퀴즈를 추천했어요" />
        <meta
          property="og:description"
          content="교사 업무를 빠르게 끝내는 AI 도구와 친구 초대 혜택을 확인해보세요."
        />
        <meta
          property="og:image"
          content="https://whatquiz.co.kr/images/og-image.png"
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="invite-welcome-hero">
        <div className="invite-welcome-logo">
          <WhatQuizElephant size={68} />
        </div>
        <p className="invite-welcome-eyebrow">선생님을 위한 AI 도구</p>
        <h1>
          {currentUser
            ? '이미 왓퀴즈를 이용하고 계시네요'
            : '친구 선생님이 왓퀴즈를 추천했어요'}
        </h1>
        <p className="invite-welcome-description">
          생기부, PPT, 학습지, 채점을 한 곳에서 빠르게 끝내보세요.
        </p>
      </section>

      {loading ? (
        <section
          className="invite-welcome-benefits invite-welcome-benefits-loading"
          aria-label="초대 혜택 확인 중"
        >
          <span />
          <span />
        </section>
      ) : hasBenefits && !currentUser ? (
        <section className="invite-welcome-benefits" aria-labelledby="invite-benefit-title">
          <h2 id="invite-benefit-title">함께 시작하면 받는 혜택</h2>
          {signupEnabled && (
            <div className="invite-welcome-benefit">
              <span className="invite-welcome-check" aria-hidden="true">✓</span>
              <p>
                가입하면 두 분 모두
                <strong> PRO {policy.signup_days_each || 7}일</strong>
              </p>
            </div>
          )}
          {discountEnabled && (
            <div className="invite-welcome-benefit">
              <span className="invite-welcome-check" aria-hidden="true">✓</span>
              <p>
                첫 결제는
                <strong>
                  {' '}{Number(
                    policy.first_payment_discount || 10000
                  ).toLocaleString()}원 할인
                </strong>
              </p>
            </div>
          )}
        </section>
      ) : null}

      <button
        className="invite-welcome-cta"
        onClick={handleStart}
        type="button"
      >
        {currentUser ? '왓퀴즈로 이동하기' : '무료로 시작하기'}
      </button>
      {!currentUser && (
        <p className="invite-welcome-assurance">카드 등록 없이 시작할 수 있어요</p>
      )}
    </main>
  );
};

export default InviteWelcomePage;
